var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Button, Flex, FormControl, FormHelperText, FormLabel, HStack, Input, Select, Spinner, Switch, Text, Textarea, useToast } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import '@mdxeditor/editor/style.css';
import './TextContentElement.css';
import { useFocus } from "./useFocus";
import { useContentManagement } from "./ContentManagementProvider";
import Markdown from "react-markdown";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
const defaults = {
    formId: null
};
function isForm(element) {
    return element.type === "form";
}
export const FormContentElement = (props) => {
    var _a, _b;
    const { isEditing } = useContentManagement();
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    const [formDefinition, setFormDefinition] = useState(null);
    const [inputs, setInputs] = useState([]);
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    useEffect(() => {
        if (!isForm(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "form", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    useEffect(() => {
        const loadForm = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!isForm(props.contentElement) || props.contentElement.data == null || props.contentElement.data.formId == null) {
                return;
            }
            const response = yield fetch("/form/" + props.contentElement.data.formId);
            const formDefinition = yield response.json();
            setFormDefinition(formDefinition);
            setInputs(formDefinition.fields.map(field => field.type === "select" && field.options[0] ? field.options[0] : ""));
        });
        loadForm();
    }, [props.contentElement.data]);
    const submit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isForm(props.contentElement) || props.contentElement.data == null || props.contentElement.data.formId == null) {
            return;
        }
        if (!formDefinition) {
            return;
        }
        setLoading(true);
        const response = yield fetch("/form/" + props.contentElement.data.formId + "/send", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ inputs })
        });
        setLoading(false);
        if (response.status !== 200) {
            return toast({
                status: "error",
                title: "Es gab ein Problem beim Absenden Ihrer Eingabe.",
                description: "Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut."
            });
        }
        return toast({
            status: "success",
            title: "Erfolgreich",
            isClosable: true,
            description: formDefinition.successMessage,
            duration: null
        });
    });
    if (!isForm(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Form", attachTo: ref },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Form ID"),
                    React.createElement(Input, { value: (_b = (_a = props.contentElement.data.formId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "", onChange: (event) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { formId: parseInt(event.target.value) }) })) }))),
        isEditing && props.contentElement.data.formId === null ?
            React.createElement(Text, null, "Set a form id in content settings")
            :
                formDefinition ?
                    React.createElement(Flex, { as: "form", onSubmit: event => {
                            event.preventDefault();
                            submit();
                        }, flexDirection: "column", alignItems: "stretch", gap: 4, flex: 1 },
                        formDefinition.fields.map((field, index) => {
                            if (field.type === "text") {
                                return (React.createElement(FormControl, { key: index, isRequired: field.required },
                                    React.createElement(FormLabel, null, field.label),
                                    field.multiline ?
                                        React.createElement(Textarea, { value: inputs[index], onChange: event => setInputs(inputs.map((input, inputIndex) => inputIndex === index ? event.target.value : input)) })
                                        :
                                            React.createElement(Input, { value: inputs[index], onChange: event => setInputs(inputs.map((input, inputIndex) => inputIndex === index ? event.target.value : input)) })));
                            }
                            if (field.type === "select") {
                                return (React.createElement(FormControl, { key: index },
                                    React.createElement(FormLabel, null, field.label),
                                    React.createElement(Select, { value: inputs[index], onChange: event => setInputs(inputs.map((input, inputIndex) => inputIndex === index ? event.target.value : input)) }, field.options.map((option, optionIndex) => React.createElement("option", { key: optionIndex, value: option }, option)))));
                            }
                            if (field.type === "checkbox") {
                                return (React.createElement(FormControl, { key: index, isRequired: field.required },
                                    React.createElement(HStack, null,
                                        React.createElement(Switch, { isChecked: inputs[index] === "true", onChange: event => setInputs(inputs.map((input, inputIndex) => inputIndex === index ? (event.target.checked ? "true" : "false") : input)) }),
                                        React.createElement(FormLabel, null, field.label)),
                                    field.help && React.createElement(FormHelperText, null,
                                        React.createElement(Markdown, { components: ChakraUIRenderer() }, field.help))));
                            }
                            return null;
                        }),
                        React.createElement(Button, { type: "submit", isLoading: loading }, "Absenden"))
                    :
                        React.createElement(Spinner, null)));
};
